import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useLevels } from "@dyl/systems/LevelsManager";
import useExport from './useAssetExport';

export default function useLogic(module) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const { globalLevel } = useLevels();
    const [isExporting, setExporting] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [isUpdatingSelection, setUpdatingSelection] = useState(false);
    const [searchId, setSearchId] = useState('');
    const exportLimit = 100;

    const selectAll = useCallback(async () => {
        setUpdatingSelection(true);
        setUpdatingSelection(false);
    }, [searchId]);

    //EXPORT ASSETS
    const exportAssets = useExport();
    const onExportClick = async (value) => {
        let indicatorId;

        let selectedIds = [];
        if (Array.isArray(value)) {
            selectedIds = value;
        } else if (typeof value === "string") {
            selectedIds = [value];
        } else if (value && typeof value === "object") {
            selectedIds = Object.values(value).flat();
        }

        if (selectedIds.length === 0) {
            return enqueueSnackbar('Please Select Atleast One Asset To Export', { variant: 'error' });
        }

        const selectedForExport = selectedIds.slice(0, exportLimit);

        if (selectedForExport.length < selectedIds.length) {
            return enqueueSnackbar(`Only ${exportLimit} Assets can be exported at once.`, { variant: 'error' });
        } else {
            indicatorId = enqueueSnackbar(`Exporting ${selectedIds.length} Assets`, {
                variant: 'info',
                persist: true,
            });
        }

        setExporting(true);

        try { await exportAssets(selectedForExport, module, globalLevel.level_id); }
        finally {
            setExporting(false);
            closeSnackbar(indicatorId);
        }
    };

    return {
        isLoading: isUpdatingSelection,
        selectedIds, setSelectedIds,
        isExporting, onExportClick,
        selectAll,
        searchId, setSearchId,
    };
}